<div class="col-card">
  <div class="col-head">
    <div class="col-icon"><i class="bi bi-inbox"></i></div>
    <div class="col-head-text">
      <div class="col-title-row">
        <span class="col-title">Needs review</span>
        <span class="col-count" *ngIf="totalCount">{{ totalCount }}</span>
      </div>
      <p class="col-desc">Records Sage and Aivor disagree on, waiting for your decision.</p>
    </div>
    <button class="col-link" (click)="openQueue.emit()">Open queue</button>
  </div>

  <div class="col-body" *ngIf="loading">
    <div class="col-empty"><i class="bi bi-arrow-repeat spin"></i><span>Loading&hellip;</span></div>
  </div>

  <div class="col-body" *ngIf="!loading && groups.length">
    <div class="group" *ngFor="let g of groups; trackBy: trackGroup">
      <div class="group-main">
        <div class="group-title-row">
          <span class="group-label">{{ g.label }}</span>
          <span class="group-count">{{ g.count }}</span>
        </div>
        <div class="group-sub" *ngIf="examplesLabel(g)">{{ examplesLabel(g) }}</div>
        <div class="group-actions">
          <button class="btn-outline" (click)="openGroup.emit(g)">{{ g.action }}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-body" *ngIf="!loading && !groups.length">
    <div class="col-empty">
      <i class="bi bi-check-circle"></i>
      <span>Nothing waiting for review</span>
    </div>
  </div>
</div>
